import { memoizeFunction, mergeStyles } from '@ms/yammer-web-core-ui/dist/util/styling';

export const applyMainStyles = memoizeFunction(() =>
  mergeStyles({
    ':global(html)': {
      '@supports (font: -apple-system-body)': {
        font: '-apple-system-body',
      },
    },
  })
);
